module.exports = __webpack_public_path__ + "img/kh.8a3e559d.svg";